import { sentryCaptureException } from '@alfa-bank/site-helpers-error-handlers/sentry-logger/capture-exception';
import { sentryAddErrorBreadcrumb } from '@alfa-bank/site-helpers-error-handlers/sentry-logger/breadcrumb';
import type { Breadcrumb } from '@sentry/types';

export interface ISentryLogError {
    data?: Breadcrumb['data'];
    error?: unknown;
    message?: Breadcrumb['message'];
}

export const sentryLogError = ({ data, error, message }: ISentryLogError) => {
    console.error(error || message);

    sentryCaptureException(error, {
        packageName: 'dc-form',
        teamName: 'dc',
    });

    sentryAddErrorBreadcrumb({
        message,
        data,
    });
};

export const sentryCaptureExceptionDc = (error: unknown) =>
    sentryCaptureException(error, {
        packageName: 'dc-form',
        teamName: 'dc',
    });
